import React from "react";
import { useTranslation } from "react-i18next";
import { useFormikContext } from "formik";

import { HvGrid, HvInput } from "@hitachivantara/uikit-react-core";

import { SwitchWithLabels } from "components/form";

import useStyles from "./styles";

interface FindCameraProps {
  mode?: "add" | "selection";
}

const Location: React.FC<FindCameraProps> = ({ mode = "add" }) => {
  const { t } = useTranslation("incidentAddEdit");
  const classes = useStyles();

  const { values, setFieldValue, setFieldTouched, errors, touched } =
    useFormikContext<FindCameraFormData>();

  const parseStatus = (field: keyof FindCameraFormData, untouched = false) => {
    return errors[field] && (untouched || touched[field]) ? "invalid" : "valid";
  };

  const parseStatusMessage = (
    field: keyof FindCameraFormData,
    untouched = false
  ) => {
    return errors[field] && (untouched || touched[field]) ? errors[field] : "";
  };

  return (
    <>
      <HvGrid xs={false} item>
        <SwitchWithLabels
          className={classes.input}
          name="findCameras"
          label={t("location.fields.findCameras")}
          offLabel={t("location.fields.findCamerasOffLabel")}
          onLabel={t("location.fields.findCamerasOnLabel")}
          value="yes"
          checked={values.findCameras || false}
          onChange={(evt, value) => {
            if (mode === "add") {
              setFieldTouched("latitude");
              setFieldTouched("longitude");
            }
            setFieldValue("findCameras", value);
          }}
          onBlur={() => {
            setFieldTouched("findCameras");
          }}
        />
      </HvGrid>
      <HvGrid
        xs={12}
        md
        item
        style={{ display: values.findCameras ? "block" : "none" }}
      >
        <HvInput
          className={classes.input}
          label={t("location.fields.radius")}
          placeholder={t("location.fields.radiusPlaceholder")}
          value={values.radius?.toString() ?? ""}
          required={values.findCameras}
          status={parseStatus("radius")}
          statusMessage={parseStatusMessage("radius")}
          onChange={(evt, value) => {
            setFieldValue("radius", value);
          }}
          onBlur={() => {
            setFieldTouched("radius");
          }}
        />
      </HvGrid>
    </>
  );
};

export default Location;
